import { TableBody } from '@mui/material';
import { BaseTableBodyProps } from './BaseTableBody.types';

/**
 * The base MUI TableBody used as an entry point and as separation for mocking.
 *
 * @param classes - {@link BaseTableBodyProps.classes classes} description.
 * @param children - {@link BaseTableBodyProps.children children} description.
 */
export const BaseTableBody = ({
    classes,
    children,
}: BaseTableBodyProps) => {
    return (
        <TableBody
            classes={{
                ...classes,
            }}
        >
            {children}
        </TableBody>
    );
};